export default {
  myPublicData (state) {
    return state['AUTH.myPublicData']
  },
  myPrivateData (state) {
    return state['AUTH.myPrivateData']
  },
  colorMode (state) {
    return state['AUTH.colorMode']
  },
  myCoffees (state) {
    return state['AUTH.myCoffees']
  },
  showCuppingSettings (state) {
    return state['AUTH.showCuppingSettings']
  },
  anonUser (state) {
    return state['AUTH.anonUser']
  },
  uidNotPresent (state) {
    return state['AUTH.uidNotPresent']
  },
  myCurrentCupping (state) {
    return state['AUTH.myCurrentCupping']
  },
  
  showHeaderShop (state) {
    return state['AUTH.showHeaderShop']
  },
  loaded (state) {
    return state['AUTH.loaded']
  },
  uid (state) {
    return state['AUTH.uid']
  },
  email (state) {
    return state['AUTH.email']
  },
  username (state) {
    return state['AUTH.username']
  },
  profilePic (state) {
    return state['AUTH.profilePic']
  },
  test (state) {
    return state['AUTH.test']
  },
  friendsData (state) {
    return state['AUTH.friendsData']
  },
  friendsDataArray (state) {
    return state['AUTH.friendsDataArray']
  },
  authError (state) {
    return state['AUTH.authError']
  }
}


// WEBPACK FOOTER //
// ./src/services/AUTH/getters/index.js